import React from 'react';
import { PackageConfig } from '../types';

interface SelectedPackageFooterProps {
  visible: boolean;
  selectedPackage: PackageConfig | null;
  onConfirm: () => void;
}

export const SelectedPackageFooter: React.FC<SelectedPackageFooterProps> = ({
  visible,
  selectedPackage,
  onConfirm,
}) => {
  if (!selectedPackage) return null;

  const { name, price, originalPrice, currency, period } = selectedPackage;
  const savePercent =
    originalPrice && originalPrice > price
      ? Math.round(((originalPrice - price) / originalPrice) * 100)
      : null;

  return (
    <div className={`ms-footer${visible ? ' revealed' : ''}`}>
      <div className="ms-footer-left">
        <div className="ms-footer-label">Selected package</div>
        <div className="ms-footer-details">
          <span className="ms-footer-pack-name">{name}</span>
          <span className="ms-footer-divider">|</span>
          <span className="ms-footer-price">
            {currency}
            {price}
          </span>
          {(savePercent || originalPrice) && (
            <div className="ms-footer-discount">
              {savePercent && <span className="ms-fd-save">Save {savePercent}%</span>}
              {originalPrice && (
                <span className="ms-fd-old">
                  {originalPrice}
                  {currency} {period}
                </span>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="ms-footer-right">
        <button className="ms-footer-btn" onClick={onConfirm} type="button">
          Confirm package selection
        </button>
      </div>
    </div>
  );
};
